import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  display: flex;
  height: 400px;
  width: 350px;
  margin: 0 10px;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  ${mediaMaxWidth.mediumDesktop} {
    margin: 0 auto;
  }

  ${mediaMaxWidth.phone} {
    width: 320px;
    height: 370px;
  }

  ${mediaMaxWidth.smallPhone} {
    width: 300px;
    height: 290px;
    position: absolute;
    left: 0;
    right: 0;
  }
`;

export const Title = styled.div`
  font-family: Helvetica, Arial, sans-serif;
  opacity: 1;
  font-size: 14px;
  color: rgb(55, 61, 63);
  margin: 5px 0 20px 0;
  text-align: center;
`;

interface ILineProps {
  fillColor: string;
  bordered?: boolean;
}

export const Line = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
  font-weight: 700;
  position: relative;
  font-size: 14px;
  background-color: ${(props: ILineProps) => props.fillColor};
  border-top: ${(props: ILineProps) => props.bordered && "1px solid #fff  "};
  border-bottom: ${(props: ILineProps) => props.bordered && "1px solid #fff  "};

  .animated.delay-1 {
    animation-delay: 0.4s;
  }

  .animated.delay-2 {
    animation-delay: 0.5s;
  }

  .animated.delay-3 {
    animation-delay: 0.6s;
  }

  .animated.delay-4 {
    animation-delay: 0.7s;
  }

  .animated.delay-5 {
    animation-delay: 0.8s;
  }

  ${mediaMaxWidth.phone} {
    font-size: 12px;
  }
`;

export const Label = styled.div`
  font-weight: 700;
  margin: 4px 0;
  font-size: 1em;

  ${mediaMaxWidth.smallPhone} {
    margin: 0;
  }
`;

export const Value = styled.div`
  margin: 4px 0;
  font-size: 1.5em;

  ${mediaMaxWidth.smallPhone} {
    margin: 0;
  }
`;

interface IPercentageProps {
  itemId: number;
}

export const Percentage = styled.div`
  position: absolute;
  color: #333;
  z-index: 1;
  font-size: 1em;
  font-weight: 700;
  display: flex;
  align-items: center;
  width: 70px;
  text-align: left;
  right: ${(props: IPercentageProps) => props.itemId === 1 && "0"};
  bottom: ${(props: IPercentageProps) => props.itemId === 1 && "90px"};
  right: ${(props: IPercentageProps) => props.itemId === 2 && "-21px"};
  bottom: ${(props: IPercentageProps) => props.itemId === 2 && "227.5px"};
  right: ${(props: IPercentageProps) => props.itemId === 3 && "-1px"};
  bottom: ${(props: IPercentageProps) => props.itemId === 3 && "147.5px"};
  right: ${(props: IPercentageProps) => props.itemId === 4 && "20px"};
  bottom: ${(props: IPercentageProps) => props.itemId === 4 && "65px"};

  ${mediaMaxWidth.smallPhone} {
    font-size: 0.8em;
    right: ${(props: IPercentageProps) => props.itemId === 1 && "0"};
    bottom: ${(props: IPercentageProps) => props.itemId === 1 && "90px"};
    right: ${(props: IPercentageProps) => props.itemId === 2 && "-16px"};
    bottom: ${(props: IPercentageProps) => props.itemId === 2 && "165px"};
    right: ${(props: IPercentageProps) => props.itemId === 3 && "-5px"};
    bottom: ${(props: IPercentageProps) => props.itemId === 3 && "106px"};
    right: ${(props: IPercentageProps) => props.itemId === 4 && "5px"};
    bottom: ${(props: IPercentageProps) => props.itemId === 4 && "48px"};
  }
`;

export const TriangleOne = styled.div`
  width: 0;
  height: 0;
  border-left: 180px solid transparent;
  border-right: 125px solid transparent;
  border-bottom: 500px solid #fff;
  position: absolute;
  bottom: 0;
  left: -180px;
  z-index: 1;

  ${mediaMaxWidth.smallPhone} {
    border-right: 100px solid transparent;
  }
`;

export const TriangleTwo = styled.div`
  width: 0;
  height: 0;
  border-left: 125px solid transparent;
  border-right: 180px solid transparent;
  border-bottom: 500px solid #fff;
  position: absolute;
  bottom: 0;
  right: -180px;
  z-index: 1;

  ${mediaMaxWidth.smallPhone} {
    border-left: 100px solid transparent;
  }
`;

export const Legend = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  left: 20px;
`;

export const LegendLine = styled.div`
  color: rgb(55, 61, 63);
  font-size: 12px;
  font-family: Helvetica, Arial, sans-serif;
  display: flex;
  margin: 5px 0;
`;

interface ILegendLineDotProps {
  fillColor: string;
  bordered?: boolean;
}

export const LegendLineDot = styled.div`
  background-color: ${(props: ILegendLineDotProps) => props.fillColor};
  border-radius: 50%;
  height: 12px;
  width: 12px;
  margin-right: 4px;
`;
